import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  Button,
  IconButton,
  List,
  ListItem,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import GavelIcon from "@mui/icons-material/Gavel";
import EmailSignupModal from "./EmailSignupModal";
import prioritiesImage1 from "../images/economic-mobility.png";
import prioritiesImage1b from "../images/keeping-communicites-safe.png";
import prioritiesImage1c from "../images/caring-for-seniors.png";
import prioritiesImage2 from "../images/local-advocacy.png";
import prioritiesImage3 from "../images/strengthening-education.png";
import prioritiesImage4 from "../images/improving-transportation-infrastructure.png";
import targetImage from "../images/prioritiesHeader.jpg";
const Priorities = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [emailOpen, setEmailOpen] = useState(false);
  return (
    <Box sx={{ backgroundColor: "#FFFFFF!important" }}>
      {/* Header */}
      <Box
        sx={{
          backgroundImage: `radial-gradient(circle at 78% 30%, rgba(0, 55, 75, 0) 0%, #02449be6 100%), url(${targetImage})`,
          backgroundSize: "cover",
          backgroundPosition: isMobile ? "left" : "top",
          backgroundRepeat: "no-repeat",
          height: isMobile ? "30vh" : "50vh",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-end",
          textAlign: "center",
          p: isMobile ? 2 : 4,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            color: "white",
            fontWeight: "900!important",
            fontSize: {
              xs: "2.5rem",
              fontSize: isMobile ? "3rem!important" : "4rem!important",
              textTransform: "uppercase",
              fontWeight: "500!important",
            },
          }}
        >
          Issues
        </Typography>
      </Box>
      {/* Body */}
      <Box
        p={isMobile ? "0 16px" : "96px 96px 48px"}
        sx={{ borderTop: "1px solid #fff", background: "#02449b" }}
      >
        <Grid container alignItems="flex-start">
          {/* Advocating for Our Communities */}
          <Grid container className="section-wrap" mt={0} mb={isMobile ? 2 : 0}>
            <Grid
              item
              xs={12}
              md={3}
              my={isMobile ? 2 : 0}
              display={isMobile ? "none!important" : "flex"}
              justifyContent={"center"}
            >
              <img
                src={prioritiesImage2}
                alt="Mark community"
                style={{
                  borderRadius: 8,
                  padding: "1rem",
                  background: "#03449c",
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={7.5}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  mb: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  letterSpacing: "0!important",
                  color: "#FFF!important",
                  fontWeight: "normal!important",
                  fontSize: isMobile ? "1.5rem!important" : "2rem!important",
                }}
              >
                Advocating for Our Communities
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.25rem",

                  color: "white!important",
                }}
              >
                Northwest and Western Baltimore County are home to resilient
                families and vibrant communities — communities that deserve real
                investment and attention. I’m running to bring focused,
                community-driven solutions to the places that need them most.{" "}
                <br />
                <br /> As your County Councilmember, I will fight to:
              </Typography>
              <List
                sx={{
                  listStyleType: "disc",
                  listStylePosition: "inside",
                }}
              >
                <ListItem sx={{ display: "list-item" }}>
                  Create a Northwest Baltimore County Circulator System
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Establish a Center for Family Success in Western Baltimore
                  County
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Combat food deserts by attracting grocery investment and
                  expanding fresh food access
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Hold regular, accessible community meetings in every
                  neighborhood
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Protect and uplift marginalized communities
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Protect and expand green and open spaces
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Ensure our veterans have a seat at the table
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Expand mental and public health services
                </ListItem>
              </List>
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              sx={{ display: isMobile ? "none" : "initial" }}
            ></Grid>
          </Grid>
          {/* Expanding Economic Opportunity*/}
          <Grid
            container
            className="section-wrap"
            my={isMobile ? 2 : 12}
            sx={{
              background: isMobile ? "none" : "#106cb7",
              borderRadius: ".5rem",
            }}
          >
            {/* Divider */}
            <Grid
              item
              xs={false}
              my={18}
              sx={{ display: isMobile ? "none" : "initial", order: "1" }}
            ></Grid>
            <Grid
              item
              xs={12}
              md={7.5}
              mt={isMobile ? 2 : 2}
              sx={{
                order: isMobile ? "3" : "1",
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  mt: 3,
                  display: "flex",
                  alignItems: "center",
                  letterSpacing: "0!important",
                  color: "#FFF!important",
                  fontWeight: "normal!important",
                  fontSize: isMobile ? "1.5rem!important" : "2rem!important",
                  textWrap: "nowrap",
                }}
              >
                Expanding Economic Opportunity
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.25rem",

                  color: "white!important",
                }}
              >
                A strong local economy starts with investing in people and
                empowering small businesses. Our district is full of talent and
                entrepreneurial spirit, but too many face barriers to
                opportunity and growth. <br />
                <br /> As your County Councilmember, I will fight to:
              </Typography>
              <List
                sx={{
                  listStyleType: "disc",
                  listStylePosition: "inside",
                }}
              >
                <ListItem sx={{ display: "list-item" }}>
                  Expand access to workforce development and job training
                  programs
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Empower minority- and women-owned small businesses
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Streamline permitting and reduce red tape for entrepreneurs
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Champion the revitalization of the Liberty Road Corridor
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Support youth entrepreneurship and mentorship initiatives
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Promote fair wages, workplace protections, and benefits for
                  working families
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Attract and grow life-sciences and cybersecurity businesses
                </ListItem>
              </List>
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              my={18}
              sx={{ display: isMobile ? "none" : "initial", order: "2" }}
            ></Grid>
            <Grid
              item
              display={isMobile ? "none!important" : "flex"}
              justifyContent={"center"}
              flexDirection="column"
              alignItems="flex-end"
              xs={12}
              md={3}
              sx={{
                order: isMobile ? "1" : "3",
                padding: isMobile ? "0" : "1rem",
                maxHeight: "fit-content",
              }}
            >
              <img
                src={prioritiesImage1}
                alt="Mark community"
                style={{
                  borderRadius: 8,
                  padding: "1rem",
                  background: "#03449c",
                }}
              />
            </Grid>
          </Grid>
          {/* Strengthening Our Education System */}
          <Grid container className="section-wrap" mb={3} display={"flex"}>
            <Grid
              item
              xs={12}
              md={3}
              my={isMobile ? 2 : 0}
              display={isMobile ? "none!important" : "flex"}
              justifyContent={"center"}
            >
              <img
                src={prioritiesImage3}
                alt="Mark speaking"
                style={{ width: "100%", borderRadius: 8 }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={7.5}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  mb: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  letterSpacing: "0!important",
                  color: "#FFF!important",
                  fontWeight: "normal!important",
                  fontSize: isMobile ? "1.5rem!important" : "2rem!important",
                }}
              >
                Strengthening Our Education System
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.25rem",

                  color: "white!important",
                }}
              >
                As a proud product of Baltimore County Public Schools, I know
                firsthand the challenges our students face. While the County
                Council doesn’t manage day-to-day education policy, it plays a
                vital role in funding, facilities, and support services that
                shape school success. <br />
                <br /> As your County Councilmember, I will fight to:
              </Typography>
              <List
                sx={{
                  listStyleType: "disc",
                  listStylePosition: "inside",
                }}
              >
                <ListItem sx={{ display: "list-item" }}>
                  Provide for full funding of public schools
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Ensure teachers are paid fairly and treated with respect
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Empower schools to provide wraparound services for students
                  and families
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Invest in after-school programs, youth jobs, and mentorship
                  opportunities
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Fight for equitable distribution of capital funding
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Expand partnerships with nonprofits and local businesses
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Create internship programs and career pathways through county
                  agencies
                </ListItem>
              </List>
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              sx={{ display: isMobile ? "none" : "initial" }}
            ></Grid>
          </Grid>
          {/* Keeping Our Communities Safe*/}
          <Grid
            container
            className="section-wrap"
            my={isMobile ? 2 : 12}
            sx={{
              background: isMobile ? "none" : "#106cb7",
              borderRadius: ".5rem",
            }}
          >
            {/* Divider */}
            <Grid
              item
              xs={false}
              my={18}
              sx={{ display: isMobile ? "none" : "initial", order: "1" }}
            ></Grid>
            <Grid
              item
              xs={12}
              md={7.5}
              mt={isMobile ? 2 : 2}
              sx={{
                order: isMobile ? "3" : "1",
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  mt: 3,
                  display: "flex",
                  alignItems: "center",
                  letterSpacing: "0!important",
                  color: "#FFF!important",
                  fontWeight: "normal!important",
                  fontSize: isMobile ? "1.5rem!important" : "2rem!important",
                  textWrap: "nowrap",
                }}
              >
                Keeping Our Communities Safe
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.25rem",

                  color: "white!important",
                }}
              >
                Everyone deserves to feel safe in their neighborhood, regardless
                of their zip code. I believe in a &quot;Whole of Public
                Safety&quot; approach that invests in police, fire, EMS, and
                focuses on community- led prevention efforts. <br />
                <br /> As your County Councilmember, I will fight to:
              </Typography>
              <List
                sx={{
                  listStyleType: "disc",
                  listStylePosition: "inside",
                }}
              >
                <ListItem sx={{ display: "list-item" }}>
                  Expand non-police crisis response units
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Ensure our police, fire, and EMS are fully funded, trained,
                  and equipped
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Increase support for domestic violence shelters and survivor
                  services
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Modernize equipment and supplies for first responders
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Build trust between law enforcement and the communities they
                  serve
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Invest in youth violence prevention and intervention programs
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Support gun violence prevention initiatives and
                  community-based solutions
                </ListItem>
              </List>
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              my={18}
              sx={{ display: isMobile ? "none" : "initial", order: "2" }}
            ></Grid>
            <Grid
              item
              display={isMobile ? "none!important" : "flex"}
              flexDirection="column"
              alignItems="flex-end"
              xs={12}
              md={3}
              sx={{
                order: isMobile ? "1" : "3",
                padding: isMobile ? "0" : "1rem",
                maxHeight: "fit-content",
              }}
            >
              <img
                src={prioritiesImage1b}
                alt="Mark community"
                style={{ width: "100%", borderRadius: 8 }}
              />
            </Grid>
          </Grid>
          {/* Improving Our Transportation &amp; Infrastructure */}
          <Grid container className="section-wrap" mb={3}>
            <Grid
              item
              xs={12}
              md={3}
              my={isMobile ? 2 : 0}
              display={isMobile ? "none!important" : "flex"}
            >
              <img
                src={prioritiesImage4}
                alt="Mark speaking"
                style={{ width: "100%", borderRadius: 8 }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={7.5}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  mb: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  letterSpacing: "0!important",
                  color: "#FFF!important",
                  fontWeight: "normal!important",
                  fontSize: isMobile ? "1.5rem!important" : "2rem!important",
                }}
              >
                Improving Our Housing, Transportation, &amp; Infrastructure
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.25rem",

                  color: "white!important",
                }}
              >
                Reliable transportation, affordable housing, and strong
                infrastructure are the foundation of a thriving community. But
                too often, residents face aging roads, limited public transit,
                and housing they can’t afford. <br />
                <br /> As your County Councilmember, I will fight to:
              </Typography>
              <List
                sx={{
                  listStyleType: "disc",
                  listStylePosition: "inside",
                }}
              >
                <ListItem sx={{ display: "list-item" }}>
                  Invest in green infrastructure and climate resilience
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Expand access to affordable housing and support inclusionary
                  zoning
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Prioritize ADA-compliant infrastructure improvements
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Work with state and federal partners to secure infrastructure
                  funding
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Implement neighborhood traffic calming and pedestrian safety
                  measures
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Ensure roads are paved, potholes are filled, and streets are
                  maintained
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Crack down on nuisance properties and illegal dumping, and
                  swiftly address code violations
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  rehabilitate aging housing and encourage mixed-use,
                  transit-oriented development.
                </ListItem>
              </List>
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              sx={{ display: isMobile ? "none" : "initial" }}
            ></Grid>
          </Grid>
          {/* Caring for Our Seniors*/}
          <Grid
            container
            className="section-wrap"
            my={isMobile ? 2 : 12}
            sx={{
              background: isMobile ? "none" : "#106cb7",
              borderRadius: ".5rem",
            }}
          >
            {/* Divider */}
            <Grid
              item
              xs={false}
              my={18}
              sx={{ display: isMobile ? "none" : "initial", order: "1" }}
            ></Grid>
            <Grid
              item
              xs={12}
              md={7.5}
              mt={isMobile ? 2 : 2}
              sx={{
                order: isMobile ? "3" : "1",
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  mt: 3,
                  display: "flex",
                  alignItems: "center",
                  letterSpacing: "0!important",
                  color: "#FFF!important",
                  fontWeight: "normal!important",
                  fontSize: isMobile ? "1.5rem!important" : "2rem!important",
                  textWrap: "nowrap",
                }}
              >
                Caring for Our Seniors
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.25rem",
                  color: "white!important",
                }}
              >
                Baltimore County’s senior population is growing, and so are the
                challenges they face. We must do more to support older adults
                aging in place, and ensure they can live peacefully in the
                communities they’ve help build. <br />
                <br /> As your County Councilmember, I will fight to:
              </Typography>
              <List
                sx={{
                  listStyleType: "disc",
                  listStylePosition: "inside",
                }}
              >
                <ListItem sx={{ display: "list-item" }}>
                  Strengthen community infrastructure for aging adults
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Expand senior property tax relief and home repair assistance
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Support the renovation and development of affordable senior
                  communities
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Invest in senior centers, wellness programming, and
                  intergenerational engagement
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  Strengthen elder abuse prevention efforts and protect
                  vulnerable seniors
                </ListItem>
              </List>
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              my={18}
              sx={{ display: isMobile ? "none" : "initial", order: "2" }}
            ></Grid>
            <Grid
              item
              display={isMobile ? "none!important" : "flex"}
              flexDirection="column"
              alignItems="flex-end"
              xs={12}
              md={3}
              sx={{
                order: isMobile ? "1" : "3",
                padding: isMobile ? "0" : "1rem",
                maxHeight: "fit-content",
              }}
            >
              <img
                src={prioritiesImage1c}
                alt="Mark community"
                style={{ width: "100%", borderRadius: 8, marginBottom: "1rem" }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {/* Footer */}
      <footer>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          mt={6}
          pb={4}
          spacing={2}
        >
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              sx={{ textTransform: "none", background: "#106cb7!important" }}
              onClick={() => setEmailOpen(true)}
            >
              Join Our Email List
            </Button>
          </Grid>
          <Grid item>
            <IconButton
              component="a"
              href="https://www.instagram.com/mark.brewster_/profilecard/?igsh=MWVrMDN0eWlzY3E0cQ==/mark_brewster"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon sx={{ color: "white" }} />
            </IconButton>
            {/* <IconButton
              component="a"
              href="https://x.com/Mark_Brewster"
              target="_blank"
              rel="noopener noreferrer"
            >
              <XIcon sx={{ color: "white" }} />
            </IconButton> */}
            <IconButton
              component="a"
              href="https://facebook.com/profile.php?id=61577947200300"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon sx={{ color: "white" }} />
            </IconButton>
          </Grid>
          <Grid item sx={{ px: 1 }}>
            <Typography
              variant="h6"
              sx={{
                border: "1px solid white",
                padding: ".1rem .5rem !important",
                borderRadius: ".25rem!important",
                color: "white",
                fontSize: "1rem!important",
                margin: "1rem",
              }}
            >
              By authority: Friends of Mark Brewster; Juna Goldstein, Treasurer
            </Typography>
          </Grid>
        </Grid>
      </footer>
      <EmailSignupModal
        open={emailOpen}
        handleClose={() => setEmailOpen(false)}
      />
    </Box>
  );
};
export default Priorities;
